/**
 * Button primitive with expo brand styling.
 * Variants: primary (yellow on dark), secondary (outline), ghost.
 */
import { cn } from '@/lib/utils'

const VARIANTS = {
  primary:
    'bg-expo-yellow text-expo-dark hover:bg-expo-yellow/90 shadow-md hover:shadow-lg',
  secondary:
    'bg-white border border-expo-dark text-expo-dark hover:bg-expo-light',
  ghost: 'text-expo-dark hover:bg-expo-light',
  danger: 'bg-red-600 text-white hover:bg-red-700',
}

const SIZES = {
  sm: 'px-3 py-1.5 text-sm rounded-lg',
  md: 'px-5 py-2.5 text-base rounded-xl',
  lg: 'px-7 py-3.5 text-base rounded-xl',
}

export function Button({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...props
}) {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center gap-2 font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed',
        VARIANTS[variant],
        SIZES[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}
